import { createSharedComposable } from '@vueuse/core';
import { useWheel } from '@vueuse/gesture';

import { useZoom } from '@/editor/composables/useZoom';

export const useEditorMouseEvents = createSharedComposable(() => {
	const { decreaseZoom, increaseZoom } = useZoom();

	useWheel(
		async (e) => {
			const { event, movement } = e;
			const wheelDeltaY = movement[1];

			let delta = 10;

			delta = Math.round((Math.abs(wheelDeltaY) * 20) / 300);
			if (delta > 20) delta = 20;
			if (delta < 1) delta = 1;

			if (e.ctrlKey) {
				event.preventDefault();
				wheelDeltaY > 0 && (await decreaseZoom(event, delta));
				wheelDeltaY < 0 && (await increaseZoom(event, delta));
			}
		},
		{
			domTarget: window,
			eventOptions: { passive: false },
		}
	);
});
